import { useTranslate } from '@/i18n/useTranslate';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { AppRoutes, generatePath } from '@/routes/appRoutes';
import { SideMenuItem } from '../SidebarContainer';
import IconProfile from 'ui-kit/lib/icons/24/Menu/UserCircle';
import IconSVGNote from 'ui-kit/lib/icons/24/Menu/Notebook';
import IconSVGEmails from 'ui-kit/lib/icons/24/Menu/Emailbook';
import IconSVGLock from 'ui-kit/lib/icons/24/Action/Lock';
import { envs } from '@/constants/envs';
import { useBreakpoint } from 'ui-kit';
import { useCompaniesMenuItems } from '@/features/sidebar/useMenuItems/useCompaniesMenuItems';

export const useMenuItems = () => {
  const { xsOnly } = useBreakpoint('xs');
  const mobile = xsOnly;
  const { t } = useTranslate('profile');
  const location = useLocation();
  const companyItems = useCompaniesMenuItems();

  return useMemo<SideMenuItem[]>(() => {
    const items: SideMenuItem[] = [
      {
        link: {
          pathname: AppRoutes.PROFILE,
          exact: true,
        },
        title: t('PROFILE'),
        selected: location.pathname === AppRoutes.PROFILE_EDIT,
        icon: <IconProfile />,
        items: [
          ...(mobile
            ? [
                {
                  link: {
                    pathname: generatePath(AppRoutes.PROFILE_PHONE_EMAILS, {
                      tabName: 'phones',
                    }),
                  },
                  title: t('PHONES'),
                  icon: <IconSVGNote />,
                },
                {
                  link: {
                    pathname: generatePath(AppRoutes.PROFILE_PHONE_EMAILS, {
                      tabName: 'emails',
                    }),
                  },
                  title: t('EMAILS'),
                  icon: <IconSVGEmails />,
                },
              ]
            : [
                {
                  link: {
                    pathname: generatePath(AppRoutes.PROFILE_PHONE_EMAILS, {
                      tabName: 'phones',
                    }),
                  },
                  title: t('PHONES_EMAILS'),
                  selected:
                    location.pathname ===
                    generatePath(AppRoutes.PROFILE_PHONE_EMAILS, {
                      tabName: 'emails',
                    }),
                  icon: <IconSVGNote />,
                },
              ]),
          {
            link: {
              pathname: AppRoutes.PROFILE_SECURITY,
              exact: true,
            },
            title: t('SECURITY_SETTINGS'),
            icon: <IconSVGLock />,
          },
        ],
        buttons: [
          {
            title: t('GO_TO_VIVICA_PATIENT'),
            link: { pathname: envs.PATIENT_PORTAL_URL },
          },
        ],
      },
      ...companyItems,
    ];
    return items;
  }, [companyItems, location.pathname, mobile, t]);
};
